import styled from 'styled-components';
import { ThemePrisma } from '@orbita-ui/brand';

export const MenuContainer = styled.div`
  position: absolute;
  top: 64px;
  background-color: ${ThemePrisma.colors.lightblue[7]};
  padding: 8px 2px;
  border-radius: 0 0 ${ThemePrisma.borderRadius.small} ${ThemePrisma.borderRadius.small};
`;

export const UserMenuContainer = styled.div`
  position: relative;
  display: flex;
  flex-direction: row;
  -webkit-box-align: center;
  align-items: center;
  padding: 0px;
  gap: 24px;

  p {
    font-family: Inter, sans-serif;
    font-size: 0.875rem;
    font-weight: 400;
    letter-spacing: 0em;
    line-height: 1.5rem;

    &.username {
      color: ${ThemePrisma.colors.gray[2]};
    }

    &.roleuser {
      color: ${ThemePrisma.colors.gray[4]};
    }
  }
`;

export const BadgeIconContainer = styled.div`
  background: ${ThemePrisma.colors.blue[5]};
  width: 40px;
  height: 40px;
  border-radius: 56px;
  position: relative;
  display: flex;
  flex-direction: row;
  align-items: center;
  -webkit-box-pack: center;
  justify-content: center;
  flex-shrink: 0;

  svg {
    color: ${ThemePrisma.colors.gray[1]} !important;
  }
`;
